module.exports = __webpack_public_path__ + "static/img/8.338f142.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/8.png
// module id = kGCf
// module chunks = 0